export const recentPurchases = [
  { name: 'Olivia W.', city: 'Toronto', country: 'Canada', time: '2 minutes ago' },
  { name: 'Lucas M.', city: 'São Paulo', country: 'Brazil', time: '4 minutes ago' },
  { name: 'Sofía R.', city: 'Madrid', country: 'Spain', time: '6 minutes ago' },
  { name: 'James T.', city: 'London', country: 'United Kingdom', time: '9 minutes ago' },
  { name: 'Chloé D.', city: 'Paris', country: 'France', time: '12 minutes ago' },
  { name: 'Matteo B.', city: 'Milan', country: 'Italy', time: '15 minutes ago' },
  { name: 'Hannah K.', city: 'Sydney', country: 'Australia', time: '19 minutes ago' },
  { name: 'Diego F.', city: 'Mexico City', country: 'Mexico', time: '23 minutes ago' },
  { name: 'Joaquín P.', city: 'Buenos Aires', country: 'Argentina', time: '27 minutes ago' },
  { name: 'Emma S.', city: 'Berlin', country: 'Germany', time: '31 minutes ago' },
]
